//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SkillItem from '@/components/Opportunities/SkillItem'
import MessageWithoutHeader from '../Shared/MessageWithoutHeader.vue'
import Button from '~/components/Shared/Button.vue'
import EXPERIENCE_STATUS from '~/constants/experience-status'

export default {
  name: 'YourSkills',
  components: {
    SkillItem,
    MessageWithoutHeader,
    Button,
  },
  props: {
    searchValue: {
      type: String,
      default: '',
    },
    renderedSkills: {
      type: Array,
      default: () => [],
    },
    allSkills: {
      type: Array,
      default: () => [],
    },
    continueSkill: {
      type: Function,
      default: () => {},
    },
    experienceStatus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modal: {
        isSkillModalActive: false,
        record: {},
      },
      MIN_SKILLS_TO_COMPLETED: 10,
    }
  },
  computed: {
    isVisibleWithouhtSkill() {
      return (
        this.allSkills.length === 0 &&
        this.experienceStatus === EXPERIENCE_STATUS.COMPLETED
      )
    },
    isVisibleIncompleted() {
      return this.experienceStatus === EXPERIENCE_STATUS.INCOMPLETED
    },
  },
  methods: {
    hiddenModal() {
      this.modal = {
        isSkillModalActive: false,
        record: {},
      }
    },
    showDetailSkill(skill) {
      this.modal = {
        isSkillModalActive: true,
        record: skill,
      }
    },
  },
}
